module.exports = __webpack_public_path__ + "pic/4.10f2fbd5.png";